module.exports = __webpack_public_path__ + "img/home.569e8718.svg";